import { useContext, useEffect, useState } from 'react'
import axios from 'axios'
import queryString from 'query-string'
import * as routes from '../routes'
import { Loading, withRouter, formatStat } from '../shared'
import { Layout, AlertContext } from '../widgets'
import { AppStoreBanner } from '../components'

const SocialLink = ({socialLink}) => {
  return socialLink.url &&
    <a href={socialLink.url} target='_blank' rel='noreferrer noopener'>
      {socialLink.service_name}
    </a>
}

const PublicUserProfile = (props) => {
  const [state, replaceState] = useState({
    loading: true,
    profile: null,
  })

  const setState = (subState) => {
    replaceState(state => {
      return {...state, ...subState}
    })
  }

  useEffect(() => {
    load()
  }, [])

  const { handleError } = useContext(AlertContext)

  const getId = () => {
    return queryString.parse(props.router.location.search).id
  }

  const load = () => {
    setState({ loading: true })
    axios.get(routes.producerPublicProfileUrl, {
      params: {
        requested_user_id: getId(),
        include_approvals: false,
      }
    }).then((response) => {
      setState({
        profile: response.data
      })
    }).catch((error) => {
      handleError(error)
    }).finally(() => {
      setState({ loading: false })
    })
  }

  if (state.loading) {
    return (<Loading />)
  }

  if (state.profile === null) {
    return <>
      <div className='welcome-title'>404</div>
      <div>There's nothing here</div>
    </>
  }

  const {
    username,
    profile: {
      profile_pics,
      bio,
      social_links,
    },
    details: {
      beat_count,
      beat_uses,
      top_track_count,
      top_track_plays,
    }
  } = state.profile

  return <div className='body-container body-container--fullscreen'>
    <Layout className='fullscreen'>
      <div className='public-user-profile-background'>
        <img src={profile_pics['400']} alt=''/>
      </div>
      <div className='public-user-profile'>
        <img className='public-user-profile__image' src={profile_pics['400']} alt='' />
        <div className='public-user-profile__username'>{username}</div>
        <div className='public-user-profile__bio'>{bio}</div>
        <div className='public-user-profile__social'>
          {social_links && social_links.map((socialLink, index) => <SocialLink key={index} socialLink={socialLink} />)}
        </div>
        <div className='public-user-profile__stats'>
          <div className='public-user-profile__stats-cell'>
            <div className='public-user-profile__stats-cell-header'>
              {formatStat(top_track_count)} Tracks
            </div>
            <div>
              {formatStat(top_track_plays)} Plays
            </div>
          </div>
          <div className='public-user-profile__stats-divider'></div>
          <div className='public-user-profile__stats-cell'>
            <div className='public-user-profile__stats-cell-header'>
              {formatStat(beat_count)} Beats
            </div>
            <div>
              {formatStat(beat_uses)} Plays
            </div>
          </div>
        </div>
        <AppStoreBanner />
      </div>
    </Layout>
  </div>
}

export default withRouter(PublicUserProfile)
